// utils/contributorStatus.js — Anamoria SPA
// v1.0 — NEW-13 shared contributor-status lookup (Aug 21, 2026)
//
// One email can hold SEVERAL contributor rows on a single space, because
// invite -> revoke -> re-invite appends rather than replaces. Building a
// Map keyed by email is last-wins, and GET /spaces/:id/contributors does
// not return rows in creation order, so a stale 'revoked' row could mask a
// live 'active' one. Any guard reading that map then believed an active
// contributor was invitable and created yet another duplicate row.
//
// Observed on space 91c6b305 (Magda) 2026-08-21: thestrategicpartner@gmail.com
// held 4 rows (3 revoked + 1 active, active newest) and resolved to 'revoked'.
//
// This lives in one place deliberately: the same lookup is needed by both
// InvitePage and BulkInvitePage, and the whole defect was two code paths
// disagreeing about the same question.

export const CONTRIBUTOR_STATUS_RANK = { active: 3, pending: 2, revoked: 1 };

/** Lowercased email -> strongest status held on this space. */
export function buildStatusByEmail(contributors = []) {
  const map = new Map();
  for (const c of contributors) {
    const key = String(c?.email || '').trim().toLowerCase();
    if (!key) continue;
    const prev = map.get(key);
    if (!prev || (CONTRIBUTOR_STATUS_RANK[c.status] || 0) > (CONTRIBUTOR_STATUS_RANK[prev] || 0)) {
      map.set(key, c.status);
    }
  }
  return map;
}

/** Revoked people stay invitable — re-inviting someone you revoked is valid. */
export function isAlreadyInSpace(status) {
  return status === 'active' || status === 'pending';
}

export function statusNoticeFor(status) {
  if (status === 'active') return 'Already in this space';
  if (status === 'pending') return "You've already invited them";
  return '';
}

export function lookupStatus(statusByEmail, email) {
  if (!statusByEmail) return undefined;
  return statusByEmail.get(String(email || '').trim().toLowerCase());
}
